import { createSelector } from "@reduxjs/toolkit";

// 1️⃣ Get all foods as array
export const selectAllFoods = createSelector(
  state => state.foods.allIds,
  state => state.foods.byId,
  (allIds, byId) => allIds.map(id => byId[id])
);

export const selectFoodById = (id) => (state) => 
  state.foods.byId[id] ?? null;

export const selectFoodByBarcode = (barcode) => (state) =>
  barcode ? state.foods.byId[state.foods.byBarcode[barcode]] ?? null : null;

// 2️⃣ Get all meals as array
export const selectAllMeals = createSelector(
  state => state.meals.allIds,
  state => state.meals.byId,
  (allIds, byId) => allIds.map(id => byId[id])
);

// 3️⃣ Get a meal by ID
export const selectMealById = mealId => state => state.meals.byId[mealId];

// 4️⃣ Get meal with its full food objects
export const selectMealWithFoods = mealId =>
  createSelector(
    state => state.meals.byId[mealId],
    state => state.foods.byId,
    (meal, foodsById) => {
      if (!meal) return null;
      return {
        ...meal,
        foods: meal.foodIds.map(id => foodsById[id]),
      };
    }
  );

// 5️⃣ Get total calories for a meal
export const selectMealCalories = mealId =>
  createSelector(selectMealWithFoods(mealId), meal =>
    meal ? meal.foods.reduce((sum, f) => sum + f.calories, 0) : 0
  );


  // selectors.js
// selectors.js
export const selectTodayTotals = (state) => {
  const meals = state.meals.byId;
  const foods = state.foods.byId;

  return state.today.entries.reduce((total, entry) => {
    if (entry.type === "meal") {
      const meal = meals[entry.mealId];
      if (!meal) return total;
      return total + Object.entries(entry.portions).reduce((sum, [foodId, grams]) => {
        const food = foods[foodId];
        if (!food) return sum;
        return sum + (food.calories * grams) / 100;
      }, 0);
    }

    if (entry.type === "food") {
      const food = foods[entry.foodId];
      if (!food) return total;
      const grams = entry.portions[entry.foodId];
      return total + (food.calories * grams) / 100;
    }

    return total;
  }, 0);
};
